export default __webpack_public_path__ + "static/media/Goorm.95fcdc43.png";